import React, { useEffect, useState } from "react";
import AdminLayout from "./Common/AdminLayout";
import EmployerLayout from "../Pages/Recuiter/Common/EmployerLayout";
import Sidebar from "../Common/Sidebar";
import { CardSkeleton } from "./Common/LoadingSkeleton";
import { PiBagSimple } from "react-icons/pi";
import { FaIndustry, FaRupeeSign, FaArrowLeft } from "react-icons/fa";
import { GoLocation } from "react-icons/go";
import { FcGraduationCap } from "react-icons/fc";
import { useNavigate, useParams } from "react-router-dom";
import { GetOneJob } from "../../Redux/Slices/JobPost";
import { useDispatch, useSelector } from "react-redux";
import { formatTimeAgo } from "../../Helper/FromatTime";
import { formatJobLocation } from "../../Helper/CoreHelper";
import "../../asset/new/css/admin-modern.css";
import "../../asset/new/css/employer-modern.css";

const JobReviewContent = ({ jobdetails, qualificationName, isEmployer }) => {
  const cardClass = isEmployer ? "employer-card" : "admin-card";
  const bodyClass = isEmployer ? "employer-card-body" : "admin-card-body";
  const titleClass = isEmployer ? "employer-page-title" : "admin-text-2xl admin-font-bold mb-2";
  const sectionTitleClass = isEmployer ? "employer-form-section-title" : "admin-card-title";
  const badgeClass = isEmployer ? "employer-badge employer-badge-info" : "admin-badge admin-badge-light";
  const mutedClass = isEmployer ? "" : "admin-text-muted";
  const statusBadgeClass = isEmployer ? "employer-badge employer-badge-warning" : "admin-badge admin-badge-info";

  const statusLabel =
    jobdetails?.admin_approval === "approved"
      ? "Approved"
      : jobdetails?.admin_approval === "rejected"
      ? "Rejected"
      : "Pending Approval";

  return (
    <>
      <div className={cardClass}>
        <div className={bodyClass}>
          <div className="m-2">
            <h5 className={titleClass}>{jobdetails?.title}</h5>
            <p className={`mb-3 ${mutedClass}`} style={isEmployer ? { color: "var(--employer-text-muted)" } : undefined}>
              {jobdetails?.company_name}
            </p>

            <div className="mb-3" style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
              <span className={statusBadgeClass}>{statusLabel}</span>
              {jobdetails?.exp?.from !== undefined && jobdetails?.exp?.to !== undefined && (
                <span className={badgeClass}>
                  <PiBagSimple style={{ fontSize: "19px" }} /> {jobdetails.exp.from} - {jobdetails.exp.to} Years
                </span>
              )}
              {jobdetails?.ctc?.from_lac !== undefined && (
                <span className={badgeClass}>
                  <FaRupeeSign style={{ fontSize: "19px" }} /> {jobdetails.ctc.from_lac}.{jobdetails.ctc.from_thousand || 0} - {jobdetails.ctc.to_lac}.{jobdetails.ctc.to_thousand || 0} Lacs
                </span>
              )}
              {formatJobLocation(jobdetails) && (
                <span className={badgeClass}>
                  <GoLocation style={{ fontSize: "19px" }} /> {formatJobLocation(jobdetails)}
                </span>
              )}
              {jobdetails?.industry?.name && (
                <span className={badgeClass}>
                  <FaIndustry style={{ fontSize: "19px" }} /> {jobdetails.industry.name}
                </span>
              )}
            </div>

            {qualificationName && (
              <p className="mb-3">
                <FcGraduationCap style={{ fontSize: "19px" }} /> {qualificationName}
              </p>
            )}

            <div className="d-flex justify-content-between align-items-center mt-3">
              <span className={badgeClass}>{jobdetails?.category}</span>
              <span style={isEmployer ? { color: "var(--employer-text-muted)", fontSize: "0.875rem" } : {}} className={isEmployer ? "" : "admin-text-sm admin-text-muted"}>
                {formatTimeAgo(new Date(jobdetails?.posted_date))}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className={`${cardClass} mt-4`}>
        <div className={bodyClass}>
          <h5 className={sectionTitleClass}>Job Description</h5>
          <div dangerouslySetInnerHTML={{ __html: jobdetails?.description }} />
          {jobdetails?.form_link && (
            <p className="mt-3">
              <strong>Application Link:</strong>{" "}
              <a href={jobdetails.form_link} target="_blank" rel="noopener noreferrer">
                {jobdetails.form_link}
              </a>
            </p>
          )}
          {jobdetails?.website_link && (
            <p className="mt-3">
              <strong>Website Link:</strong>{" "}
              <a href={jobdetails.website_link} target="_blank" rel="noopener noreferrer">
                {jobdetails.website_link}
              </a>
            </p>
          )}
        </div>
      </div>

      <div className={`${cardClass} mt-4`}>
        <div className={bodyClass}>
          <h5 className={sectionTitleClass}>Company Details</h5>
          <p>{jobdetails?.about_company || "No company details available."}</p>
        </div>
      </div>

      <div className={`${cardClass} mt-4`}>
        <div className={bodyClass}>
          <h5 className={sectionTitleClass}>Posted By</h5>
          <p><strong>{jobdetails?.created_by?.name || "N/A"}</strong></p>
          <p style={isEmployer ? { color: "var(--employer-text-muted)" } : {}} className={isEmployer ? "" : "admin-text-muted"}>
            at {jobdetails?.company_name}
          </p>
          {jobdetails?.admin_approval === "rejected" && jobdetails?.remark && (
            <p className="mt-3" style={{ color: "var(--employer-danger)" }}>
              <strong>Rejection reason:</strong> {jobdetails.remark}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

const JobReview = () => {
  const { id } = useParams();
  const role = localStorage.getItem("role");
  const isEmployer = role === "Employer";
  const isAdmin = role === "Admin";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { jobdetails } = useSelector((state) => state?.Jobs);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await dispatch(GetOneJob(id));
      setLoading(false);
    };
    fetchData();
    document.title = "Review Job | CAJobPortal";
  }, [id, dispatch]);

  const qualificationName = jobdetails?.qualification
    ?.map((value) => value.name)
    .join(", ");

  const emptyState = (
    <div className={isEmployer ? "employer-card" : "admin-card"}>
      <div className={isEmployer ? "employer-card-body employer-text-center" : "admin-card-body"}>
        <div className={isEmployer ? "" : "admin-empty-state"}>
          <h4>Job Not Found</h4>
          <p>The requested job posting could not be found.</p>
        </div>
      </div>
    </div>
  );

  const pageContent = loading ? (
    <CardSkeleton count={2} />
  ) : !jobdetails ? (
    emptyState
  ) : (
    <JobReviewContent
      jobdetails={jobdetails}
      qualificationName={qualificationName}
      isEmployer={isEmployer}
    />
  );

  if (isEmployer) {
    return (
      <div className="employer-layout">
        <Sidebar />
        <EmployerLayout breadcrumbs={["Employer", "Posted Jobs", "Job Details"]}>
          <div className="employer-page-header">
            <div>
              <button
                type="button"
                className="employer-btn employer-btn-ghost employer-btn-sm employer-mb-2"
                onClick={() => navigate("/employer/posted-jobs")}
              >
                <FaArrowLeft /> Back to Posted Jobs
              </button>
              <h1 className="employer-page-title">Job Details</h1>
            </div>
          </div>
          {pageContent}
        </EmployerLayout>
      </div>
    );
  }

  if (isAdmin) {
    return (
      <AdminLayout title="Review Job" subtitle="Review job posting details and requirements">
        {pageContent}
      </AdminLayout>
    );
  }

  return emptyState;
};

export default JobReview;
